const AimsObjectives = () => {
    return (
        <div id="aims" className="vision-card">
            <h3>AIMS & OBJECTIVES</h3>
            <p>
                A Mission Statement defines the organization's purpose and primary objectives.
                Its prime function is internal – to define the key measure or measures of the organization’s success .
                The purpose and primary objectives of this institution of learning is based on the guidelines
                laid by the founders. The purpose of education at Nav Jeevan is to train young people for
                responsible citizenship in an epoch that is witnessing bewildering change and unparalleled challenge.
                The future of any nation depends on the character of its people. Nav Jeevan seeks to send forth
                a steady stream of such men and women as will enrich the nation and serve the world.
                This can only be as they are imbued with a sense of dedication to God, devotion to duty ,
                and a desire to serve whatever be their vocation.
            </p>
        </div>

    );
};

export default AimsObjectives;